module.exports = __webpack_public_path__ + "img/right-arrow.f0a77ac8.svg";